import Glide from '@glidejs/glide';
import { gsap } from 'gsap';

// Carousel internval. Glide.js uses milliseconds 
let interval = 5000;
// Divide by 1000 because GSAP uses seconds
const gsapInterval = interval / 1000;

export default function() {
  const heroCarouselElement = document.getElementById('hero-carousel');
  if (!heroCarouselElement) return;
  interval = heroCarouselElement.dataset.interval || interval;
  console.log(interval);
  const heroCarousel = new Glide(heroCarouselElement, {
    autoplay: interval,
    animationTimingFunc: 'ease'
  });
  heroCarousel.mount();

  const lineContainer = document.createElement('div');
  const line = document.createElement('div');
  lineContainer.classList.add('hero__carousel-line-container');
  line.classList.add('hero__carousel-line');
  lineContainer.appendChild(line);
  heroCarouselElement.appendChild(lineContainer);

  const lineAnim = gsap.fromTo(line, {
    scaleX: '0%'
  }, {
    scaleX: '100%',
    duration: interval / 1000,
    transformOrigin: 'left',
    ease: 'none'
  });

  heroCarousel.on('run', () => {
    lineAnim.restart();
  });
}
